'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _specialties = require('../actions/specialties');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getMainSpecialties),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getSubSpecialties),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(specialtiesSaga);

function getMainSpecialties(action) {
  var mainSpecialtiesApi, mainSpecialtiesApiResponse;
  return _regenerator2.default.wrap(function getMainSpecialties$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          mainSpecialtiesApi = new _webUtils.API();
          _context.next = 3;
          return mainSpecialtiesApi.get(_webUtils.Urls.getMainSpecialities, [{
            key: 'language',
            value: action.culture
          }]);

        case 3:
          mainSpecialtiesApiResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(mainSpecialtiesApiResponse.status)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _specialties.SPECIALTIES.MAIN_SPECIALTIES.SUCCEEDED,
            mainSpecialties: mainSpecialtiesApiResponse.data
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _specialties.SPECIALTIES.MAIN_SPECIALTIES.FAILED,
            error: mainSpecialtiesApiResponse.data
          });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getSubSpecialties(action) {
  var subSpecialtiesApi, subSpecialtiesApiResponse;
  return _regenerator2.default.wrap(function getSubSpecialties$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          subSpecialtiesApi = new _webUtils.API();
          _context2.next = 3;
          return subSpecialtiesApi.get(_webUtils.Urls.getSubSpecialities + '?specialityKey=' + action.mainSpecialty);

        case 3:
          subSpecialtiesApiResponse = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(subSpecialtiesApiResponse.status)) {
            _context2.next = 9;
            break;
          }

          _context2.next = 7;
          return (0, _effects.put)({
            type: _specialties.SPECIALTIES.SUB_SPECIALTIES.SUCCEEDED,
            subSpecialties: subSpecialtiesApiResponse.data
          });

        case 7:
          _context2.next = 11;
          break;

        case 9:
          _context2.next = 11;
          return (0, _effects.put)({
            type: _specialties.SPECIALTIES.SUB_SPECIALTIES.FAILED,
            error: subSpecialtiesApiResponse.data
          });

        case 11:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function specialtiesSaga() {
  return _regenerator2.default.wrap(function specialtiesSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_specialties.SPECIALTIES.MAIN_SPECIALTIES.LOADING, getMainSpecialties);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeEvery)(_specialties.SPECIALTIES.SUB_SPECIALTIES.LOADING, getSubSpecialties);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = specialtiesSaga;
module.exports = exports['default'];